import Button from "@/components/bricks/button/Button";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FormikDatePicker } from "../../formcontrols/DatePicker";
import { ModalContext } from "../../Modal/Modal";
import { StickyFooter } from "../../stickyFooter/modalStickyFooter";
import { WizardReceipt } from "../common/wizardReceipt";
import { useRegistrerDoedsfald } from "./useRegistrerDoedsfald";
import { PersonDto } from "../../../interfaces/schema";
import { AlertMessage } from "../../AlertMessage";

export default function RegistrerDoedsfaldWizard(props: {
  person: PersonDto;
  invalidateData: InvalidateDataFunction<any>;
}) {
  const { person, invalidateData } = props;
  const { formik, error, isLoading, step, result } = useRegistrerDoedsfald(
    person.id,
  );

  const { handleSubmit } = formik;
  const { setModalOpen } = useContext(ModalContext);
  const navigate = useNavigate();

  return (
    <div className="c-modal-container">
      {step === 0 ? (
        <form autoComplete="off" onSubmit={handleSubmit}>
          <div className="c-item-list c-modal-container-inner">
            <div className="flex-100 mb-3">
              <FormikDatePicker
                formik={formik}
                config={{
                  component: "datepicker",
                  id: "doedDato",
                  label: "Dato for dødsfald",
                  initialValue: "",
                  isRequired: true,
                }}
              />
            </div>
            <AlertMessage type="info">
              <div className="c-card">
                <h4>OBS, dødsdato</h4>
                <p className="mt-3">
                  At registrere et dødsfald kan føre til mange ændringer i
                  koblede objekter i databasen. Vær sikker på at datoen er
                  korrekt, da dette ikke kan fortrydes eller rettes uden at
                  kontakte support.
                </p>
              </div>
            </AlertMessage>
          </div>
          <StickyFooter>
            <Button
              disabled={isLoading}
              color="secondary"
              onClick={() => {
                setModalOpen(false);
                navigate("/person/" + person.id);
              }}
            >
              Annuller
            </Button>
            <Button type="submit" color="primary" disabled={isLoading}>
              Erklær død
            </Button>
          </StickyFooter>
        </form>
      ) : (
        <>
          {isLoading && (
            <WizardReceipt
              heading="Registrerer dødsfald"
              icon="loading"
            ></WizardReceipt>
          )}
          {!isLoading && error && (
            <WizardReceipt
              heading="Kunne ikke registrere dødsfald"
              icon="warning"
            >
              <div>
                <div className="flex-100 d-flex justify-content-center mt-3">
                  {error.data ? error.data : "Noget gik galt"}
                </div>
                <div className="flex-100 d-flex justify-content-center mt-3">
                  <Button
                    color="secondary"
                    onClick={() => {
                      setModalOpen(false);
                    }}
                  >
                    Luk
                  </Button>
                </div>
              </div>
            </WizardReceipt>
          )}
          {!isLoading && !error && (
            <>
              <WizardReceipt heading="Dødsfald registreret" icon="success">
                {result && result.paavirkedeKursushold.length > 0 && (
                  <AlertMessage type="warning">
                    <span>
                      I forbindelse med registreringen af dødsfald er der
                      foretaget automatisk afmelding af kurser, som personen var
                      tilmeldt. Du bedes underrette Kursusafdelingen herom.
                    </span>
                  </AlertMessage>
                )}
              </WizardReceipt>
              <div className="flex-100 d-flex justify-content-center mt-3">
                <Button
                  color="secondary"
                  onClick={() => {
                    setModalOpen(false);
                    invalidateData();
                  }}
                >
                  Luk
                </Button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
